function getScrollbarWidth() {

    // Creating invisible container
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // forcing scrollbar to appear
    outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
    document.body.appendChild(outer);
  
    // Creating inner element and placing it in the container
    const inner = document.createElement('div');
    outer.appendChild(inner);
  
    // Calculating difference between container's full width and the child width
    const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);
  
    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);
  
    return scrollbarWidth;
  
}

function isDate(txt) {
    var matches = txt.match(/^\d?\d\/(\d?\d)\/\d{4}$/);
    return !!matches && !!Date.parse(txt) && new Date(txt).getDate()==matches[1];
}

export function popupReservation() {   
    
    $('input[name="date"]').on('change keypress', function (){
        let _date = $(this).val();         
        if(isDate(_date)){
            $(this).removeClass('wpcf7-not-valid');  
            console.log('valid');          
        }else{
            $(this).addClass('wpcf7-not-valid');            
            console.log('no valid'); 
        }
    });

    $(".cta-reservation").on("click", function(event) {
        event.preventDefault();
        let widthBody = document.querySelector("body").offsetWidth;
        const ScrollbarWidth = getScrollbarWidth();
        document.querySelector("body").classList.add('fixed-scroll');
        document.querySelector("html").style.paddingRight = ScrollbarWidth + 'px';
        document.querySelector("header").style.width = widthBody + 'px';
        $('.popup-form').hide();

        let idForm = $(this).data('form');
        $('#' + idForm + '-form' ).show();

        setTimeout(() => {            
            $('.reservation-modal').fadeIn();
            $('.reservation-modal__close-button').click(function () {
                $('.reservation-modal').fadeOut(0);
                document.querySelector("body").classList.remove('fixed-scroll');
                document.querySelector("html").style.paddingRight = '0';
            });           
        }, 300);
    });       
    
    document.addEventListener( 'wpcf7submit', function( event ) {            
        //if ( '1911' == event.detail.contactFormId ) {
            if(event.detail.status == 'validation_failed'){ 
                event.preventDefault();                   
                $('.reservation-modal').stop().animate({scrollTop: 0}, 600);                    
            }
        //}
    }, false );

}


// WEBPACK FOOTER //
// ./assets/js/modules/cta-reservation.js